export default {
    "id": "0DCF0013-57AC-4BDB-82C5-F897E904A122",
    "hash": "-1048848141",
    "certifiedDate": "2016-10-31",
    "lang": "en-us",
    "docType": "enhancedshareddp",
    "title": {
        "consumer": "Knee Osteoarthritis: Is It Time to Think About Surgery?"
    },
    "legal": {
        "logoUrl": "https://cdn.healthwise.net/common/images/hwlogo/hwlogo.png",
        "copyrightText": "© 1995-2018 Healthwise, Incorporated. Healthwise, Healthwise for every health decision, and the Healthwise logo are trademarks of Healthwise, Incorporated.",
        "disclaimerText": "This information does not replace the advice of a doctor. Healthwise, Incorporated, disclaims any warranty or liability for your use of this information.",
        "termsOfUseUrl": "https://www.healthwise.org/specialpages/legal/terms.aspx",
        "privacyPolicyUrl": "https://www.healthwise.org/specialpages/legal/privacy.aspx",
        "moreInformationUrl": "https://www.healthwise.org",
        "toLearnMoreHtml": "To learn more about Healthwise, visit <a href=\"https://www.healthwise.org\">Healthwise.org</a>.",
        "yourUseOfThisInformationHtml": "Your use of this information means that you agree to the <a href=\"https://www.healthwise.org/specialpages/legal/terms.aspx\">Terms of Use</a> and <a href=\"https://www.healthwise.org/specialpages/legal/privacy.aspx\">Privacy Policy</a>.",
        "html": "<div class=\"HwLegal\"><div class=\"HwLogo\"><img width=\"112\" height=\"46\" src=\"https://cdn.healthwise.net/common/images/hwlogo/hwlogo.png\" alt=\"\"/></div><div class=\"HwDisclaimer\"><p>This information does not replace the advice of a doctor. Healthwise, Incorporated, disclaims any warranty or liability for your use of this information. Your use of this information means that you agree to the <a href=\"https://www.healthwise.org/specialpages/legal/terms.aspx\">Terms of Use</a> and <a href=\"https://www.healthwise.org/specialpages/legal/privacy.aspx\">Privacy Policy</a>.</p></div><div class=\"HwCopyright\"><p class=\"HwCopyrightLink\">To learn more about Healthwise, visit <a href=\"https://www.healthwise.org\">Healthwise.org</a>.</p><p>© 1995-2018 Healthwise, Incorporated. Healthwise, Healthwise for every health decision, and the Healthwise logo are trademarks of Healthwise, Incorporated.</p></div></div>"
    },
    "navigation": {
        "html": null,
        "topics": [{
            "id": "29EFF69E-AF6C-4AC0-B4A4-9E96339F5973",
            "title": "Home",
            "tab": "home",
            "visited": true
        }, {
            "id": "E13C0714-6323-4EFC-8FAB-201F930C44AE",
            "title": "Facts",
            "tab": "facts",
            "visited": false
        }, {
            "id": "3BDBB678-6534-4EDE-B381-D63273F51CA6",
            "title": "Compare",
            "tab": "compare",
            "visited": false
        }, {
            "id": "BF94110E-935C-4AD1-AF75-A1FF867F0CFC",
            "title": "Learn",
            "tab": "learn",
            "visited": false
        }, {
            "id": "07B32256-C609-45DE-989A-254C10F2DF29",
            "title": "Decide",
            "tab": "decide",
            "visited": false
        }, {
            "id": "57CC0731-1A49-4230-9AE7-012E37C5C82B",
            "title": "Summary",
            "tab": "summary",
            "visited": false
        }]
    },
    "credits": {
        "author": {
            "name": "Healthwise Staff"
        },
        "primaryReviewers": [{
            "name": "Adam Husney MD - Family Medicine"
        }, {
            "name": "Jeffrey N. Katz MD, MPH - Rheumatology"
        }, {
            "name": "Elizabeth T. Russo MD - Internal Medicine"
        }, {
            "name": "Kathleen Romito MD - Family Medicine"
        }, {
            "name": "Martin J. Gabica MD - Family Medicine"
        }, {
            "name": "Anne C. Poinier MD - Internal Medicine"
        }, {
            "name": "Kenneth J. Koval MD - Orthopedic Surgery, Orthopedic Trauma"
        }, {
            "name": "David Bardana MD, FRCSC - Orthopedic Surgery, Sports Medicine"
        }, {
            "name": "Catherine D. Serio PhD - Behavioral Health"
        }],
        "secondaryReviewers": []
    },
    "topics": [{
        "id": "29EFF69E-AF6C-4AC0-B4A4-9E96339F5973",
        "version": "3",
        "type": "esdpHome",
        "title": {
            "consumer": "Home"
        },
        "navigable": false,
        "topics": [{
            "id": "abx0682",
            "version": "5",
            "hash": "5",
            "certifiedDate": "2017-03-21",
            "lang": "en-us",
            "type": "hwDecisionComponent",
            "title": {
                "consumer": "Knee Osteoarthritis: Is It Time to Think About Surgery?"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Adam Husney MD - Family Medicine, Jeffrey N. Katz MD; MPH - Rheumatology"
                }]
            },
            "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwDecisionComponent\"> <h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">Knee Osteoarthritis: Is It Time to Think About Surgery?</h3> <div class=\"HwSection\"> <p>The pain and stiffness from knee osteoarthritis can make it hard for you to do your daily tasks. And it can keep you from doing the things you like to do. But you have options. You can have surgery to replace your knee. Or you can try treatments that don't involve surgery—things like exercise, medicines for pain, steroid shots into the knee joint, physical therapy, or losing weight (if you need to). </p> <p><em>Only you know which choice is right for you.</em> What you decide will depend on what matters most to you. Let's take a few minutes to explore your options and what you prefer. </p> </div> </div></div></section>",
            "taxonomy": [{
                "aspect": {
                    "id": "decisionOverview",
                    "label": "Decision overview",
                    "href": null
                },
                "concept": {
                    "id": "HWCV_21268",
                    "label": "Knee Problems and Injuries",
                    "href": null
                }
            }],
            "aspect": "Decision overview [decisionOverview]"
        }, {
            "id": "abx0657",
            "version": "5",
            "hash": "5",
            "certifiedDate": "2017-03-21",
            "lang": "en-us",
            "type": "hwDecisionComponent",
            "title": {
                "consumer": "Decision Options"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Adam Husney MD - Family Medicine"
                }]
            },
            "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwDecisionComponent\"> <h3 class=\"HwNoTitle\" data-element=\"title\" role=\"heading\" aria-level=\"3\">Decision Options</h3> <div class=\"HwSection\"> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/1359be2d-ee73-4392-9d0d-ce2e55b704e2/1359be2d-ee73-4392-9d0d-ce2e55b704e2.svg\" data-image-filename=\"ba_GUID-1359BE2D-EE73-4392-9D0D-CE2E55B704E2_i_n_l.svg\" class=\"HwImage\" /></div> <p> Knee replacement surgery offers better pain relief. But it also has some risks. </p> </div> <div class=\"HwSection\"> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/7887a607-51db-4cf1-8508-758108d93b3c/7887a607-51db-4cf1-8508-758108d93b3c.svg\" data-image-filename=\"ba_GUID-7887A607-51DB-4CF1-8508-758108D93B3C_i_n_l.svg\" class=\"HwImage\" /></div> <p> Nonsurgical treatments have fewer risks. But they may not work as well to relieve pain. </p> </div> </div></div></section>",
            "taxonomy": [{
                "aspect": {
                    "id": "decisionOptions",
                    "label": "Decision options",
                    "href": null
                },
                "concept": {
                    "id": "HWCV_21268",
                    "label": "Knee Problems and Injuries",
                    "href": null
                }
            }],
            "aspect": "Decision options [decisionOptions]"
        }, {
            "id": "abx0476",
            "version": "3",
            "hash": "3",
            "certifiedDate": "2017-03-21",
            "lang": "en-us",
            "type": "hwDecisionAssessment",
            "title": {
                "consumer": "We're Curious"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Adam Husney MD - Family Medicine, Jeffrey N. Katz MD; MPH - Rheumatology"
                }]
            },
            "content": [{
                "type": "hwDecisionAssessment",
                "interactions": [{
                    "type": "hwSingleSelectOpinion",
                    "id": "8D117012-11BC-481F-8C32-5855501CA3BC",
                    "question": "<div>Right now, what treatment are you leaning toward for your knee pain?</div>",
                    "answers": [{
                        "id": "8B2EDFBF-7519-44D0-A84A-D866B3657EFF",
                        "answer": "<div>Knee replacement surgery</div>"
                    }, {
                        "id": "0D9DBE8E-36B9-4D3A-A08F-2BC7F4A3D135",
                        "answer": "<div>Nonsurgical treatments</div>"
                    }, {
                        "id": "FE173F26-5E93-4465-822E-AFFF7FB469BF",
                        "answer": "<div>I'm not sure</div>"
                    }]
                }, {
                    "type": "hwSingleSelectOpinion",
                    "id": "B53486A4-71BD-421F-A8D8-5A119B04EF7F",
                    "question": "<div>How far along are you with this decision?</div>",
                    "answers": [{
                        "id": "E95349A0-F933-46B5-8456-A8C87EFDFE22",
                        "answer": "<div>Not yet thought about all the options</div>"
                    }, {
                        "id": "A736B47A-A788-48E7-BB75-F30E5C26978F",
                        "answer": "<div>Considering the different options</div>"
                    }, {
                        "id": "4F99D781-4D64-48A5-8B61-9DEE574EBD92",
                        "answer": "<div>Close to choosing an option</div>"
                    }]
                }],
                "navigable": "true"
            }]
        }, {
            "id": "acc4253",
            "version": "7",
            "hash": "7",
            "certifiedDate": "2017-06-05",
            "lang": "en-us",
            "type": "hwMessage",
            "title": {
                "consumer": "Home CTA"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Elizabeth T. Russo MD - Internal Medicine"
                }]
            },
            "html": "<div class=\"HwStructuredWrapper\"><h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">When You're Done </h3><div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/a7019a36-b312-480a-9cfc-4486ca76a5e5/a7019a36-b312-480a-9cfc-4486ca76a5e5.svg\" data-image-filename=\"ba_GUID-A7019A36-B312-480A-9CFC-4486CA76A5E5_i_n_l.svg\" class=\"HwImage HwIconTitle\" /></div><p>This decision aid won't make your decision for you. But it will help you think about what matters to you and what questions you may have for your doctor. At the end, you'll get a summary of which way you're leaning and what matters most to you. You can share that with your doctor or loved ones. </p></div>",
            "outputClass": "HwCTA"
        }]
    }, {
        "id": "E13C0714-6323-4EFC-8FAB-201F930C44AE",
        "version": "2",
        "type": "esdpFacts",
        "title": {
            "consumer": "Facts"
        },
        "navigable": false,
        "topics": [{
            "id": "abx0683",
            "version": "5",
            "hash": "5",
            "certifiedDate": "2017-03-21",
            "lang": "en-us",
            "type": "hwDecisionComponent",
            "title": {
                "consumer": "Key Facts to Know"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Adam Husney MD - Family Medicine, Jeffrey N. Katz MD; MPH - Rheumatology"
                }]
            },
            "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwDecisionComponent\"> <h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">Key Facts to Know</h3> <div class=\"HwSection\"> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/c3452187-409f-47c0-ae04-dd69745fb023/c3452187-409f-47c0-ae04-dd69745fb023.svg\" data-image-filename=\"ba_GUID-C3452187-409F-47C0-AE04-DD69745FB023_i_n_l.svg\" class=\"HwImage HwIconTitle\" /></div> <ul> <li><em>Knee arthritis symptoms may come and go.</em> They don't always get worse over time. </li> <li><em>Nonsurgical treatments help many people feel better and do more, often for a long time.</em> But for people who have severe knee arthritis, they may not work as well as knee replacement surgery. </li> <li><em>Knee replacement surgery usually works very well.</em> After surgery, most people have much less pain and can do more activities. </li> <li><em>Knee replacement surgery is a major surgery.</em> Risks aren't common, but they can be serious. Recovery also takes work and time. </li> <li><em>Most knee replacements last for at least 10 years.</em> For some people, it makes sense to delay surgery for as long as they can to reduce the chance of needing to replace the joint again later. On the other hand, if you wait too long to have surgery, you might have a harder time with strength and range of motion after surgery. </li> </ul> </div> </div></div></section>"
        }, {
            "id": "D2E671DF-564A-444D-9C75-73B4A7BA7BF4",
            "version": "3",
            "type": "Gallery",
            "title": {
                "consumer": "Gallery"
            },
            "navigable": false,
            "topics": [{
                "id": "abx1485",
                "version": "2",
                "hash": "2",
                "certifiedDate": "2016-10-31",
                "lang": "en-us",
                "type": "hwVideo",
                "title": {
                    "consumer": "Knee Arthritis: Treatments"
                },
                "abstract": {
                    "consumer": "Learn about the different treatment options for knee arthritis, and hear stories of what others have tried.",
                    "clinical": "Discusses the range of treatment options for knee arthritis, including lifestyle changes to knee replacement surgery."
                },
                "navigable": false,
                "credits": {
                    "author": {
                        "name": "Healthwise Staff"
                    },
                    "primaryReviewers": [{
                        "name": "Kathleen Romito MD - Family Medicine, Martin J. Gabica MD - Family Medicine, Jeffrey N. Katz MD; MPH - Rheumatology"
                    }]
                },
                "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwMedia\"><h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">Knee Arthritis: Treatments</h3><div class=\"HwVideo\"><video controls=\"true\" preload=\"true\" class=\"HwVideoTag\" crossorigin=\"anonymous\" poster=\"https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5105/SD/abq5105.jpg\"><source src=\"https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5105/SD/hls/EF0/filesequence.m3u8?Expires=1526509544&amp;Signature=Jr~O0TYYQzbU6bEcfa21cJ-nGWHGAww8fKicuROu4iHAb2xuin5-t0g4q2yWIBeEDbTpGQPHPNjQXYM~iyubq5siQHMrESshpQeKke~ER-UbzSBjdufd2RFal4WHPy4fLsAbCljsOmCRCqaQgYygKLjdL~6L0QwJndU-OZaujjE_&amp;Key-Pair-Id=APKAIDLZDAU235UUEL6A\" type=\"application/x-mpegURL\" /><source src=\"https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5105/SD/E0/abq5105.mp4?Expires=1526509544&amp;Signature=hkGcUMwC8lvTtfpzFiQrG4FCro7TqLTN0GdWXKOJE-7NDjoxd64CEDI1TZVPXabSuUVFrst4~pFpGcldjA~WPevaESt0tlcaBLlTnKSX1wmg5Jvrqn13au7knkUoPKeL6jCDkHrFkJRhhmDWByZhQ7eXiElrNDQbUFD8ZcbfNxs_&amp;Key-Pair-Id=APKAIDLZDAU235UUEL6A\" type=\"video/mp4\" /><track label=\"English\" kind=\"captions\" srclang=\"English\" src=\"https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5105/abq5105.vtt\" /></video></div></div></div></section>",
                "taxonomy": [{
                    "aspect": {
                        "id": "treatmentOptions",
                        "label": "Treatment options",
                        "href": null
                    },
                    "concept": {
                        "id": "HWCV_20488",
                        "label": "Knee Arthritis",
                        "href": null
                    }
                }],
                "aspect": "Treatment options [treatmentOptions]",
                "thumbnail": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5105/SD/abq5105.jpg",
                "duration": "00:02:08",
                "transcript": {
                    "html": "<p>[Dr. Tomek] \"Arthritis affects different people differently.</p><p>The disease progresses at a different rate in everyone, and for a lot of people arthritis can stay very stable for years.</p><p>In other patients the arthritis progresses much quicker.\"</p><p>[Azell] \"About 2, 3 o'clock, I could feel myself limping.</p><p>That's what bothered me the most. I didn't want to walk around limping.\"</p><p>[Dr. Tomek] \"Knee osteoarthritis treatment often starts with lifestyle changes ... weight loss, improving exercise, becoming more active ... in spite of the knee pain.\"</p><p>[Bill] \"Right now with the exercises that I'm doing and with the cortisone shots and ibuprofen, it's helped me tolerate the pain.</p><p>So I can put off this surgery for a little while.\"</p><p>[Dr. Tomek] \"If lifestyle changes, exercise, weight loss, over-the-counter medications don't work, surgery is something that we discuss with patients.</p><p>And the surgery that most often gets discussed is total knee replacement.</p><p>The major benefit of a knee replacement is that in the vast majority of patients it reduces knee pain, allowing patients to get back to activities that they may have avoided for a long time.</p><p>The downside of knee replacement is that a small number of patients may have a complication associated with the surgery.</p><p>The recovery after knee replacement varies between patients.</p><p>Some patients recover very quickly and get back to a point of walking and activities that, frankly, sometimes are surprising to me.</p><p>Other patients take longer.\"</p><p>[Susan] \"Since the surgery, I don't have the strength that I would like to have in my leg.</p><p>It's probably a little better than what I had before I went in for the surgery.</p><p>I just never have gotten it all the way back to 100% of normal.\"</p><p>[Dr. Tomek] \"In the long term as knee implants age, some patients may need another operation to replace parts of the implant that have worn out. Everyone is different.</p><p>Everyone has different motivations and goals with respect to their knee arthritis.</p><p>And the more that your physician understands this, the more they'll be able to guide you with your decision.\"</p>"
                },
                "sources": {
                    "mp4_1080p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5105/SD/E3/abq5105.mp4?Expires=1526509544&Signature=f5MYT3cZflpsKlpYHcLN4n5N3acSIq492otlS63CL~Lj1qTzDhYoSj~p2Y3r7KJR8~RmOpHspCGh3XopEn4nfDN84-2Hrm5D-U1jBQC7zFNxzda-NhYjxITPnOQ~fLD0Sq1fAo7v2NWPEREBBZZc-xr49fmrMtV~zXvRzwPIPPg_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "mp4_720p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5105/SD/E4/abq5105.mp4?Expires=1526509544&Signature=Y8qU7wgFDGTyOriRY8fq41r6fCzdtXzjB5SD4oL9n3C25boCQ2gWlRPjbI6WROLGYBFfM~LTdcb9BeChirRwbNRJujteTIg29TWKyEQyqZSrnrTWSBsDf0cFqGj~4naXVSdn9hJ7zvDaTY7-f4-weB79VoNKPjoKi2dHV2ZB9UE_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "mp4_288p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5105/SD/E0/abq5105.mp4?Expires=1526509544&Signature=hkGcUMwC8lvTtfpzFiQrG4FCro7TqLTN0GdWXKOJE-7NDjoxd64CEDI1TZVPXabSuUVFrst4~pFpGcldjA~WPevaESt0tlcaBLlTnKSX1wmg5Jvrqn13au7knkUoPKeL6jCDkHrFkJRhhmDWByZhQ7eXiElrNDQbUFD8ZcbfNxs_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "hls_600k_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5105/SD/hls/EF1/filesequence.m3u8?Expires=1526509544&Signature=melfWLF2RXh97EZAjbfO4txVdi8LUYSfN~V7~WOyZ2FkJwxpeyWNCWWhRn89cyU5kDaDmCuwkufFy408lubLOQpTaIararpZRtlQZHeAToIjtdUvp~qdOjXY80DANVT6zN~FF48b-qg06K5uPAqdP4awnV~6NastXq~81vnEf6s_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "hls_400k_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5105/SD/hls/EF0/filesequence.m3u8?Expires=1526509544&Signature=Jr~O0TYYQzbU6bEcfa21cJ-nGWHGAww8fKicuROu4iHAb2xuin5-t0g4q2yWIBeEDbTpGQPHPNjQXYM~iyubq5siQHMrESshpQeKke~ER-UbzSBjdufd2RFal4WHPy4fLsAbCljsOmCRCqaQgYygKLjdL~6L0QwJndU-OZaujjE_&Key-Pair-Id=APKAIDLZDAU235UUEL6A"
                },
                "closedCaptions": {
                    "sbv_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5105/abq5105.sbv",
                    "srt_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5105/abq5105.srt",
                    "vtt_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5105/abq5105.vtt",
                    "xml_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5105/abq5105.xml"
                },
                "learningObjectiveText": {
                    "html": "<p>Users will learn about different treatment options for knee arthritis.</p>"
                },
                "clinicalAbstract": {
                    "html": "<p>Discusses the range of treatment options for knee arthritis, including lifestyle changes to knee replacement surgery.</p>"
                },
                "teaser": {
                    "html": "<p>Learn about the different treatment options for knee arthritis, and hear stories of what others have tried.</p>"
                },
                "hwid": "abq5105"
            }, {
                "id": "zm6212",
                "version": "3",
                "hash": "3",
                "certifiedDate": "2017-03-21",
                "lang": "en-us",
                "type": "hwSlideshow",
                "title": {
                    "consumer": "Knee replacement surgery"
                },
                "navigable": false,
                "credits": {
                    "author": {
                        "name": "Healthwise Staff"
                    },
                    "primaryReviewers": [{
                        "name": "Anne C. Poinier MD - Internal Medicine, Adam Husney MD - Family Medicine, Kenneth J. Koval MD - Orthopedic Surgery; Orthopedic Trauma, David Bardana MD; FRCSC - Orthopedic Surgery; Sports Medicine"
                    }]
                },
                "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwActionTask\"> <h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">Knee replacement surgery</h3> <ol class=\"HwOrderedSteps\"> <li> <div class=\"HwCmd\">Normal knee joint. </div> <div class=\"HwInfo\"><div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/fd7e5e2e-b22b-5867-a05e-4bf8c148920d/fd7e5e2e-b22b-5867-a05e-4bf8c148920d.jpg\" data-image-filename=\"bf_GUID-fd7e5e2e-b22b-5867-a05e-4bf8c148920d_m_n_l.jpg\" alt=\"Normal knee joint\" data-image-type=\"medical\" class=\"HwMedicalImage\" /></div> <p> Inside a normal knee joint, thick cushioning (cartilage) covers and protects the ends of your bones. This is called hyaline cartilage. Another type of cartilage, called meniscal cartilage or meniscus, acts like a shock absorber between the bones and keeps the knee joint stable by spreading out the load evenly across the joint. The two menisci (plural of meniscus) protect and cushion the surface of the joint and the ends of your bones. </p> </div> </li> <li> <div class=\"HwCmd\">Osteoarthritis of the knee. </div> <div class=\"HwInfo\"><div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/e9d5a6d9-0300-50ae-a5e6-3683114fad2e/e9d5a6d9-0300-50ae-a5e6-3683114fad2e.jpg\" data-image-filename=\"bf_GUID-e9d5a6d9-0300-50ae-a5e6-3683114fad2e_m_n_l.jpg\" alt=\"Knee joint with osteoarthritis\" data-image-type=\"medical\" class=\"HwMedicalImage\" /></div> <p>In osteoarthritis, the cartilage that protects and cushions the knee joint breaks down over time. As the cartilage wears down, the bone surfaces rub against each other. This damages the tissue and bone, causing pain. Osteoarthritis is common in the knee joints. </p> </div> </li> <li> <div class=\"HwCmd\">Femoral component is placed. </div> <div class=\"HwInfo\"><div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/c2abd1da-9912-5518-9d40-3e2181e0d02c/c2abd1da-9912-5518-9d40-3e2181e0d02c.jpg\" data-image-filename=\"bf_GUID-c2abd1da-9912-5518-9d40-3e2181e0d02c_m_n_l.jpg\" alt=\"Knee replacement surgery: Femoral component\" data-image-type=\"medical\" class=\"HwMedicalImage\" /></div> <p> The damaged cartilage is removed from the lower end of the femur and the femoral component is placed. </p> </div> </li> <li> <div class=\"HwCmd\">Tibial component is placed. </div> <div class=\"HwInfo\"><div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/594106fc-c7ef-5a08-86b9-48089292cd57/594106fc-c7ef-5a08-86b9-48089292cd57.jpg\" data-image-filename=\"bf_GUID-594106fc-c7ef-5a08-86b9-48089292cd57_m_n_l.jpg\" alt=\"Knee replacement surgery: Tibial component\" data-image-type=\"medical\" class=\"HwMedicalImage\" /></div> <p>The damaged cartilage is removed from the upper end of the tibia and the tibial component is placed. </p> </div> </li> <li> <div class=\"HwCmd\">Patellar component is placed. </div> <div class=\"HwInfo\"><div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/25af7b96-31a4-5d4e-aeb6-c31d7aa6c2ef/25af7b96-31a4-5d4e-aeb6-c31d7aa6c2ef.jpg\" data-image-filename=\"bf_GUID-25af7b96-31a4-5d4e-aeb6-c31d7aa6c2ef_m_n_l.jpg\" alt=\"Knee replacement surgery: Patellar component\" data-image-type=\"medical\" class=\"HwMedicalImage\" /></div> <p> The damaged cartilage is removed from the patella and the patellar component is placed. </p> </div> </li> <li> <div class=\"HwCmd\">Knee replacement surgery is complete. </div> <div class=\"HwInfo\"><div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/bad580b1-8c5d-51a8-b280-20877b2d4609/bad580b1-8c5d-51a8-b280-20877b2d4609.jpg\" data-image-filename=\"bf_GUID-bad580b1-8c5d-51a8-b280-20877b2d4609_m_n_l.jpg\" alt=\"Completed knee replacement surgery\" data-image-type=\"medical\" class=\"HwMedicalImage\" /></div> </div> </li> </ol></div></div></section>",
                "taxonomy": [{
                    "aspect": {
                        "id": "howDone",
                        "label": "How it's done",
                        "href": null
                    },
                    "concept": {
                        "id": "HWCV_21977",
                        "label": "Knee Replacement Surgery",
                        "href": null
                    }
                }],
                "aspect": "How it's done [howDone]"
            }]
        }, {
            "id": "acc0397",
            "version": "4",
            "hash": "4",
            "certifiedDate": "2017-06-05",
            "lang": "en-us",
            "type": "hwMessage",
            "title": {
                "consumer": "Facts CTA"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Elizabeth T. Russo MD - Internal Medicine"
                }]
            },
            "html": "<div class=\"HwStructuredWrapper\"><p>Let's explore your options. </p></div>",
            "outputClass": "HwCTA"
        }]
    }, {
        "id": "3BDBB678-6534-4EDE-B381-D63273F51CA6",
        "version": "1",
        "type": "esdpCompare",
        "title": {
            "consumer": "Compare"
        },
        "navigable": false,
        "topics": [{
            "id": "abx0686",
            "version": "6",
            "hash": "6",
            "certifiedDate": "2017-03-21",
            "lang": "en-us",
            "type": "hwDecisionComponent",
            "title": {
                "consumer": "Compare Your Options"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Adam Husney MD - Family Medicine, Jeffrey N. Katz MD; MPH - Rheumatology"
                }]
            },
            "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwDecisionComponent\"> <h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">Compare Your Options</h3> <div class=\"HwSection\"> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/beb11f81-5d05-417c-8b5d-ccacdb36c1ae/beb11f81-5d05-417c-8b5d-ccacdb36c1ae.svg\" data-image-filename=\"ba_GUID-BEB11F81-5D05-417C-8B5D-CCACDB36C1AE_i_n_l.svg\" class=\"HwImage HwIconTitle\" /></div> <table> <tgroup cols=\"3\"><thead> <tr> <th colname=\"col1\">​</th> <th colname=\"col2\"><p>Knee Replacement Surgery </p></th> <th colname=\"col3\"><p>Nonsurgical Treatments </p></th> </tr></thead> <tbody> <tr> <td colname=\"col1\"> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/966557b8-bf41-4e62-baff-fa4ee2b104af/966557b8-bf41-4e62-baff-fa4ee2b104af.svg\" data-image-filename=\"ba_GUID-966557B8-BF41-4E62-BAFF-FA4EE2B104AF_i_n_l.svg\" class=\"HwImage\" /></div> <p>What's involved </p> </td> <td colname=\"col2\"> <ul> <li>Major surgery. </li> <li>Short hospital stay. </li> <li>Physical therapy for several weeks, including exercises you can do at home. </li> <li>Most knee replacements last for at least 10 years. Out of 100 people who have the surgery, about 5 will need to have their knee replaced again within 10 years. Knee replacements don't last as long in men and in people who are young, active, or overweight. </li> </ul> </td> <td colname=\"col3\"> <p>Any or all of these: </p> <ul> <li>Exercise and weight loss. </li> <li>Physical therapy. </li> <li>Pain medicines (pills, skin creams). </li> <li>Steroid shots into the knee joint. </li> <li>Acupuncture and massage. </li> <li>Dietary supplements. </li> <li>Knee braces, canes, and other walking aids. </li> </ul> </td> </tr> <tr> <td colname=\"col1\"> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/38645992-460d-4fbb-ba81-ce0005080790/38645992-460d-4fbb-ba81-ce0005080790.svg\" data-image-filename=\"ba_GUID-38645992-460D-4FBB-BA81-CE0005080790_i_n_l.svg\" class=\"HwImage\" /></div> <p>Pain relief </p> </td> <td colname=\"col2\"> <ul> <li> Surgery works well for most people. Six months after knee replacement, about 80 out of 100 people have less pain and can do more activities than they could before the surgery.<iconarray minRange=\"80\" maxRange=\"80\" total=\"100\" iconType=\"male\">​</iconarray> </li> </ul> </td> <td colname=\"col3\"> <ul> <li> Nonsurgical treatments work well for some people. For example: <ul> <li> Leg and knee exercises can reduce pain and stiffness. And being active can make it easier to move around. </li> <li> If you're overweight, losing even a few pounds can reduce your knee pain. </li> <li> Steroid shots may give quick pain relief for a few weeks. </li> </ul> </li> <li>But for severe knee arthritis, nonsurgical treatments may not work as well as surgery. </li> </ul> </td> </tr> <tr> <td colname=\"col1\"> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/91466eb6-7398-4e4b-9d7b-15ea33a7937c/91466eb6-7398-4e4b-9d7b-15ea33a7937c.svg\" data-image-filename=\"ba_GUID-91466EB6-7398-4E4B-9D7B-15EA33A7937C_i_n_l.svg\" class=\"HwImage\" /></div> <p>Risks </p> </td> <td colname=\"col2\"> <ul> <li> About 4 out of 100 people have a serious complication like a joint infection, a blood clot, or a heart attack within 3 months after surgery. <iconarray minRange=\"4\" maxRange=\"4\" total=\"100\" iconType=\"male\">​</iconarray> </li> </ul> <ul> <li> If you are older or have other health problems, your risk may be higher. </li> </ul> </td> <td colname=\"col3\"> <ul> <li>In general, these treatments have fewer risks than surgery. Some may have side effects. For example, any medicine used to treat pain can have side effects. </li> </ul> </td> </tr> <tr> <td colname=\"col1\"> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/26d2b509-f716-4370-b18f-cf1bd305cb05/26d2b509-f716-4370-b18f-cf1bd305cb05.svg\" data-image-filename=\"ba_GUID-26D2B509-F716-4370-B18F-CF1BD305CB05_i_n_l.svg\" class=\"HwImage\" /></div> <p>Recovery </p> </td> <td colname=\"col2\"> <ul> <li>It usually takes people about 3 months to get back to doing most of their usual activities. But it may take a little longer than that for some people. </li> <li> It may take 6 to 12 months to make a full recovery and reach your maximum knee strength and range of motion. </li> </ul> </td> <td colname=\"col3\"> <ul> <li> In general, these treatments allow you to keep doing most of your usual activities. But your knee pain may limit how much you can do. </li> </ul> </td> </tr> <tr> <td colname=\"col1\"> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/844c0c42-574d-436d-8733-8806e1a77042/844c0c42-574d-436d-8733-8806e1a77042.svg\" data-image-filename=\"ba_GUID-844C0C42-574D-436D-8733-8806E1A77042_i_n_l.svg\" class=\"HwImage\" /></div> <p>Cost </p> </td> <td colname=\"col2\"> <ul> <li>The cost of surgery varies. Check your insurance coverage. </li> <li>Also think about costs of help you may need during recovery. </li> </ul> </td> <td colname=\"col3\"> <ul> <li>This may include the costs of over-the-counter pills or creams, walking aids, or treatments that your insurance doesn't cover. </li> </ul> </td> </tr> </tbody> </tgroup> </table> </div> </div></div></section>"
        }, {
            "id": "acc0388",
            "version": "5",
            "hash": "5",
            "certifiedDate": "2017-06-05",
            "lang": "en-us",
            "type": "hwMessage",
            "title": {
                "consumer": "Compare CTA"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Elizabeth T. Russo MD - Internal Medicine"
                }]
            },
            "html": "<div class=\"HwStructuredWrapper\"><p>Ready to test your knowledge? </p></div>",
            "outputClass": "HwCTA"
        }]
    }, {
        "id": "BF94110E-935C-4AD1-AF75-A1FF867F0CFC",
        "version": "1",
        "type": "esdpLearn",
        "title": {
            "consumer": "Learn"
        },
        "navigable": false,
        "topics": [{
            "id": "abx0687",
            "version": "6",
            "hash": "6",
            "certifiedDate": "2017-03-21",
            "lang": "en-us",
            "type": "hwDecisionAssessment",
            "title": {
                "consumer": "Check the Facts"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Adam Husney MD - Family Medicine, Jeffrey N. Katz MD; MPH - Rheumatology"
                }]
            },
            "content": [{
                "intro": "<div><div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/020cdef3-a3cc-4015-bd19-70a6c1084b9a/020cdef3-a3cc-4015-bd19-70a6c1084b9a.svg\" data-image-filename=\"ba_GUID-020CDEF3-A3CC-4015-BD19-70A6C1084B9A_i_n_l.svg\" class=\"HwImage HwIconTitle\" /></div><p>Now that you've read the facts about each option, let's see what you've learned. We've got a few quick questions to find out. If you're not sure about the answers, check the Compare page again. Or you can make a note to ask your doctor for more information. </p></div>",
                "type": "hwDecisionAssessment",
                "interactions": [{
                    "type": "hwSingleSelectQuiz",
                    "id": "45AB39C3-AB0D-4C7C-87E6-E9FB3429EF09",
                    "question": "<div>Which treatment is most likely to provide relief from severe knee pain caused by osteoarthritis?</div>",
                    "answers": [{
                        "id": "686BB62D-73C9-4127-A459-DBA70702BCB2",
                        "answer": "<div>Surgery</div>",
                        "feedback": "<div>Correct</div>",
                        "correctAnswer": "true"
                    }, {
                        "id": "3895A083-6EF4-49E3-BDF1-14B1A0186570",
                        "answer": "<div>Nonsurgical treatments</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "A77F0579-54AE-4F14-92BF-909C6F222567",
                        "answer": "<div>Both are about the same</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "DAF8111F-40EA-4F43-A6CC-DDB93B74D8DA",
                        "answer": "<div>I'm not sure</div>",
                        "feedback": "<div>Incorrect</div>"
                    }]
                }, {
                    "type": "hwSingleSelectQuiz",
                    "id": "CBEF352D-20B8-4DAE-9F43-0D8F6178A14A",
                    "question": "<div>If 100 people have knee replacement surgery, about how many will need to have the same knee replaced again in less than 10 years?</div>",
                    "answers": [{
                        "id": "C77AC0EA-CE62-42E7-A948-03385C7DDE44",
                        "answer": "<div>More than half</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "CB29818C-5D85-4D8B-A882-47E7150900E7",
                        "answer": "<div>About half</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "C2173870-F3C5-40B7-AEC7-4CD0D50CF95D",
                        "answer": "<div>Less than half</div>",
                        "feedback": "<div>Correct</div>",
                        "correctAnswer": "true"
                    }, {
                        "id": "5EA1DF45-D08B-415A-83FF-5EBED740CD97",
                        "answer": "<div>I'm not sure</div>",
                        "feedback": "<div>Incorrect</div>"
                    }]
                }, {
                    "type": "hwSingleSelectQuiz",
                    "id": "CD5CE9F4-E114-4B3F-9276-4301BC9E0C8E",
                    "question": "<div>Take 100 people who have knee replacement surgery. Six months later, about how many will have less knee pain than they had before the surgery?</div>",
                    "answers": [{
                        "id": "EADE9CAC-653A-497A-9CE9-6225D37E69FB",
                        "answer": "<div>20</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "78E2D4A3-4F8B-46FD-9DC9-1523593F5452",
                        "answer": "<div>40</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "64A8E7FC-C09D-4B11-8045-AC817A689659",
                        "answer": "<div>60</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "5C09A9AD-D78A-457F-86CC-503478089977",
                        "answer": "<div>80</div>",
                        "feedback": "<div>Correct</div>",
                        "correctAnswer": "true"
                    }, {
                        "id": "94F087ED-2190-4F08-8972-9D9A1C5C3C15",
                        "answer": "<div>I'm not sure</div>",
                        "feedback": "<div>Incorrect</div>"
                    }]
                }, {
                    "type": "hwSingleSelectQuiz",
                    "id": "7C723441-9FCB-4E68-B3C1-CCC400BB1318",
                    "question": "<div>Serious complications can happen after knee replacement surgery, including life-threatening blood clots, infections, heart attacks, and even death. If 100 people have knee replacement surgery, about how many will have a serious complication within 3 months after surgery?</div>",
                    "answers": [{
                        "id": "C1882206-5FFC-4F4B-9CC1-9378E8604611",
                        "answer": "<div>4</div>",
                        "feedback": "<div>Correct</div>",
                        "correctAnswer": "true"
                    }, {
                        "id": "AF5A4807-CFA4-4825-A186-F147932667A1",
                        "answer": "<div>10</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "88D7E73B-0F9C-4954-A0CD-C038A0C50806",
                        "answer": "<div>14</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "A2E5557B-B1CF-4D68-807C-5E25B1155057",
                        "answer": "<div>20</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "7C8572F2-96AA-4508-8939-948F2069F880",
                        "answer": "<div>I'm not sure</div>",
                        "feedback": "<div>Incorrect</div>"
                    }]
                }, {
                    "type": "hwSingleSelectQuiz",
                    "id": "6628DF77-A452-4995-AA1B-DF8707BF6794",
                    "question": "<div>After knee replacement surgery, about how many months does it take most people to get back to doing their usual activities?</div>",
                    "answers": [{
                        "id": "1409CC6F-8E58-4D8C-A87D-17E5E3A1F4CC",
                        "answer": "<div>Less than 2 months</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "8ED217D3-88BE-4249-8146-DDE39EEBB286",
                        "answer": "<div>2 to 6 months</div>",
                        "feedback": "<div>Correct</div>",
                        "correctAnswer": "true"
                    }, {
                        "id": "F2AA090D-7260-4AD5-9EB2-1870659FADA9",
                        "answer": "<div>7 to 12 months</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "65F2929E-3C3E-42DC-A0B6-E126743CFC60",
                        "answer": "<div>More than 12 months</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "09A744B1-B681-4287-8E1E-97980782ECFF",
                        "answer": "<div>I'm not sure</div>",
                        "feedback": "<div>Incorrect</div>"
                    }]
                }],
                "altTitle": "Knowledge Questions",
                "navigable": "true"
            }]
        }, {
            "id": "acc0392",
            "version": "4",
            "hash": "4",
            "certifiedDate": "2017-06-05",
            "lang": "en-us",
            "type": "hwMessage",
            "title": {
                "consumer": "Learn CTA"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Elizabeth T. Russo MD - Internal Medicine"
                }]
            },
            "html": "<div class=\"HwStructuredWrapper\"><p> Now let's think about what's right for you. </p></div>",
            "outputClass": "HwCTA"
        }]
    }, {
        "id": "07B32256-C609-45DE-989A-254C10F2DF29",
        "version": "3",
        "type": "esdpDecide",
        "title": {
            "consumer": "Decide"
        },
        "navigable": false,
        "topics": [{
            "id": "acc4252",
            "version": "5",
            "hash": "5",
            "certifiedDate": "2017-06-05",
            "lang": "en-us",
            "type": "hwDecisionComponent",
            "title": {
                "consumer": "Decide What's Right for You"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Elizabeth T. Russo MD - Internal Medicine"
                }]
            },
            "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwDecisionComponent\"> <h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">Decide What's Right for You</h3> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/d8d97996-f05c-4006-b836-0a8896230ec2/d8d97996-f05c-4006-b836-0a8896230ec2.svg\" data-image-filename=\"ba_GUID-D8D97996-F05C-4006-B836-0A8896230EC2_i_n_l.svg\" class=\"HwImage HwIconTitle\" /></div> <div class=\"HwSection\"> <p>What you decide will depend on how you feel about the benefits and risks of each option. Talk to your doctor about what matters most to you. Together, you can make the decision that's right for you. </p> </div> </div></div></section>"
        }, {
            "id": "abx0518",
            "version": "6",
            "hash": "6",
            "certifiedDate": "2017-03-21",
            "lang": "en-us",
            "type": "hwDecisionAssessment",
            "title": {
                "consumer": "What Matters to You?"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Adam Husney MD - Family Medicine, Jeffrey N. Katz MD; MPH - Rheumatology"
                }]
            },
            "content": [{
                "intro": "<div><p> On a scale from 0 to 10, with 0 being not at all important and 10 being extremely important, please mark how important each reason is to you as you think about your decision. </p><p class=\"HwLeadIn\">How important is it to you to… </p></div>",
                "type": "hwDecisionAssessment",
                "interactions": [{
                    "type": "hwSingleSelectScale",
                    "minValueText": "Not at all important",
                    "maxValueText": "Extremely important",
                    "minValue": "0",
                    "maxValue": "10",
                    "answerId": "50121A94-35F3-4727-A7FD-4CB73D6F28B4",
                    "id": "D0C86392-8A1E-482A-8EF3-F0D30F22EA2F",
                    "question": "<div>Relieve your knee pain?</div>"
                }, {
                    "type": "hwSingleSelectScale",
                    "minValueText": "Not at all important",
                    "maxValueText": "Extremely important",
                    "minValue": "0",
                    "maxValue": "10",
                    "answerId": "AD0D709C-88AC-479E-A449-F973E08185CD",
                    "id": "A4A1BC36-AA4B-4BF8-B3A7-E3BAFDAC1E50",
                    "question": "<div>Not be limited in what you can do because of your knee pain?</div>"
                }, {
                    "type": "hwSingleSelectScale",
                    "minValueText": "Not at all important",
                    "maxValueText": "Extremely important",
                    "minValue": "0",
                    "maxValue": "10",
                    "answerId": "F02D2D26-6C68-4CEF-B18C-CC38C340D52C",
                    "id": "FC8A6FA1-2503-4481-B1D0-45A964C55443",
                    "question": "<div>Avoid taking pain medicine for a long time?</div>"
                }, {
                    "type": "hwSingleSelectScale",
                    "minValueText": "Not at all important",
                    "maxValueText": "Extremely important",
                    "minValue": "0",
                    "maxValue": "10",
                    "answerId": "25F797CD-EBA1-45E8-9011-C0FF990DDBC6",
                    "id": "64CB932E-B8EF-47FD-BBE1-A04F9ECEB8AE",
                    "question": "<div>Avoid having knee surgery?</div>"
                }, {
                    "type": "hwSingleSelectScale",
                    "minValueText": "Not at all important",
                    "maxValueText": "Extremely important",
                    "minValue": "0",
                    "maxValue": "10",
                    "answerId": "9E368D3E-486D-4953-888F-AD8B1CF99D14",
                    "id": "3EBA6B06-5395-43D8-B670-4AE9B9F20147",
                    "question": "<div>Avoid a treatment with a long recovery time?</div>"
                }],
                "altTitle": "Values",
                "navigable": "true"
            }]
        }, {
            "id": "acc4255",
            "version": "7",
            "hash": "7",
            "certifiedDate": "2017-06-05",
            "lang": "en-us",
            "type": "hwDecisionAssessment",
            "title": {
                "consumer": "Your Notes"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Elizabeth T. Russo MD - Internal Medicine"
                }]
            },
            "content": [{
                "type": "hwDecisionAssessment",
                "interactions": [{
                    "type": "hwOpenQuestion",
                    "answerId": "948E76EC-F994-4EAD-8205-2E684B0C4CE8",
                    "id": "948E76EC-F994-4EAD-8205-2E684B0C4CE8",
                    "question": "<div> Questions, concerns, or notes:</div>"
                }],
                "altTitle": "Concerns/Questions",
                "navigable": "true"
            }]
        }, {
            "id": "abx0519",
            "version": "3",
            "hash": "3",
            "certifiedDate": "2017-03-21",
            "lang": "en-us",
            "type": "hwDecisionAssessment",
            "title": {
                "consumer": "Which Way Are You Leaning?"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Adam Husney MD - Family Medicine, Jeffrey N. Katz MD; MPH - Rheumatology"
                }]
            },
            "content": [{
                "type": "hwDecisionAssessment",
                "interactions": [{
                    "type": "hwSingleSelectOpinion",
                    "id": "6FFBF2E7-78F7-4B2A-9F06-FCBAE435DC39",
                    "question": "<div>At this time, what treatment are you leaning toward for your knee pain?</div>",
                    "answers": [{
                        "id": "195D7BDC-30A9-44C3-98B8-9778A4FBC7E7",
                        "answer": "<div>Knee replacement surgery</div>"
                    }, {
                        "id": "2942075F-9B46-4825-96E6-D5A181E9731B",
                        "answer": "<div>Nonsurgical treatments</div>"
                    }, {
                        "id": "D1671833-220B-4C85-BDB6-8100194F7D55",
                        "answer": "<div>I'm not sure</div>"
                    }]
                }, {
                    "type": "hwSingleSelectOpinion",
                    "id": "BF31AD83-C34A-4DFE-A4F7-DB9E301DD508",
                    "question": "<div>How far along are you with this decision?</div>",
                    "answers": [{
                        "id": "C4305F08-9876-4FE8-A43B-50A2F58A09D4",
                        "answer": "<div>Not yet thought about all the options</div>"
                    }, {
                        "id": "B3708DC0-BB0C-40D8-B7B1-D0D49D51FD40",
                        "answer": "<div>Considering the different options</div>"
                    }, {
                        "id": "68AB5E26-3207-41E4-898D-1E3109E4B8E7",
                        "answer": "<div>Close to choosing an option</div>"
                    }]
                }],
                "altTitle": "Treatment Preference",
                "navigable": "true"
            }]
        }, {
            "id": "acc4251",
            "version": "7",
            "hash": "7",
            "certifiedDate": "2017-06-05",
            "lang": "en-us",
            "type": "hwMessage",
            "title": {
                "consumer": "Decide CTA"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Elizabeth T. Russo MD - Internal Medicine"
                }]
            },
            "html": "<div class=\"HwStructuredWrapper\"><p> You're almost done! Complete this final step to see a summary of your responses. The summary may help you talk with your doctor or loved ones about your decision. </p></div>",
            "outputClass": "HwCTA"
        }]
    }, {
        "id": "57CC0731-1A49-4230-9AE7-012E37C5C82B",
        "version": "2",
        "type": "decisionSummary",
        "title": {
            "consumer": "Summary"
        },
        "navigable": false,
        "topics": [{
            "id": "acc0395",
            "version": "6",
            "hash": "6",
            "certifiedDate": "2017-06-05",
            "lang": "en-us",
            "type": "hwDecisionComponent",
            "title": {
                "consumer": "Your Decision Summary"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Elizabeth T. Russo MD - Internal Medicine"
                }]
            },
            "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwDecisionComponent\"> <h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">Your Decision Summary</h3> <div class=\"HwSection\"> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/28c9e1db-e6b6-420b-b84a-cf6d452f88b8/28c9e1db-e6b6-420b-b84a-cf6d452f88b8.svg\" data-image-filename=\"ba_GUID-28C9E1DB-E6B6-420B-B84A-CF6D452F88B8_i_n_l.svg\" class=\"HwImage HwIconTitle\" /></div> <p> This summary of your responses shows which way you're leaning and what matters most to you. </p> </div> </div></div></section>",
            "taxonomy": [{
                "aspect": {
                    "id": "decisionOverview",
                    "label": "Decision overview",
                    "href": null
                },
                "concept": {
                    "id": "HWCV_21268",
                    "label": "Knee Problems and Injuries",
                    "href": null
                }
            }],
            "aspect": "Decision overview [decisionOverview]"
        }, {
            "id": "acc4254",
            "version": "7",
            "hash": "7",
            "certifiedDate": "2017-06-05",
            "lang": "en-us",
            "type": "hwMessage",
            "title": {
                "consumer": "Summary CTA"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Elizabeth T. Russo MD - Internal Medicine"
                }]
            },
            "html": "<div class=\"HwStructuredWrapper\"><p> Print or email a copy to help you talk with your doctor or loved ones about your decision. </p></div>",
            "outputClass": "HwCTA"
        }, {
            "id": "1F26B8D3-D1B2-464B-A938-C71352421DB3",
            "version": "2",
            "type": "Gallery",
            "title": {
                "consumer": "Explore Your Next Step"
            },
            "navigable": false,
            "topics": [{
                "id": "abx0479",
                "version": "3",
                "hash": "3",
                "certifiedDate": "2017-03-21",
                "lang": "en-us",
                "type": "hwVideo",
                "title": {
                    "consumer": "Knee Replacement Surgery"
                },
                "abstract": {
                    "consumer": "Learn what to expect during knee replacement surgery and how it can ease the pain of arthritis.",
                    "clinical": "Discusses cartilage damage in the knee. Shows how damaged parts of the knee are removed and replaced during surgery."
                },
                "navigable": false,
                "credits": {
                    "author": {
                        "name": "Healthwise Staff"
                    },
                    "primaryReviewers": [{
                        "name": "Adam Husney MD - Family Medicine"
                    }]
                },
                "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwMedia\"><h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">Knee Replacement Surgery</h3><div class=\"HwVideo\"><video controls=\"true\" preload=\"true\" class=\"HwVideoTag\" crossorigin=\"anonymous\" poster=\"https://assetpool.test.hwapps.net/11.7/en-us/desktop/abn1940/SD/abn1940.jpg\"><source src=\"https://d20bb9v528piij.cloudfront.net/11.7/en-us/abn1940/SD/hls/EF0/filesequence.m3u8?Expires=1526509545&amp;Signature=nSJtcKxNbX8fdUWVEeinZT3oK00ztjGYq~Hip2PByS3pPnTiMxEe5C~ZdOka6Ne5xzVJdhvwm4YEGa7FUVJ9R79vV1qpkpi90mbapu2BRjRvQBFI6nKTPikwfVpv9Q--UhA8Wjf6gDElSe2vpZDMtgz9mHPXl9-anC02hbTDTjs_&amp;Key-Pair-Id=APKAIDLZDAU235UUEL6A\" type=\"application/x-mpegURL\" /><source src=\"https://d20bb9v528piij.cloudfront.net/11.7/en-us/abn1940/SD/E0/abn1940.mp4?Expires=1526509545&amp;Signature=aaJVy4jbhs6vH4vBY65PVdvmselrnfoemQLZDn3yl5F0~xDFzWilaUTzxK5qRNtPf0zbrOrWf3OMpQMeVrhIYxSQtWI-CqU5sjB2cjC8HeCtBD1jpaPpmdHPS61dwl8I-SivKL05t3wayxi2vEmK7KBd-Q1N17-fhjlDWusa~pA_&amp;Key-Pair-Id=APKAIDLZDAU235UUEL6A\" type=\"video/mp4\" /><track label=\"English\" kind=\"captions\" srclang=\"English\" src=\"https://assetpool.test.hwapps.net/11.7/en-us/desktop/abn1940/abn1940.vtt\" /></video></div></div></div></section>",
                "taxonomy": [{
                    "aspect": {
                        "id": "overview",
                        "label": "Overview",
                        "href": null
                    },
                    "concept": {
                        "id": "HWCV_21977",
                        "label": "Knee Replacement Surgery",
                        "href": null
                    }
                }],
                "aspect": "Overview [overview]",
                "thumbnail": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abn1940/SD/abn1940.jpg",
                "duration": "00:01:44",
                "transcript": {
                    "html": "<p>Your knee is a joint that connects the thighbone to the shinbone.</p><p>The joint is covered by another bone-the kneecap.</p><p>The joint is cushioned and protected by cartilage.</p><p>But if you have arthritis, this protective surface breaks down.</p><p>As the cartilage breaks down, the bony surfaces of the joint rub against each other, which causes damage and pain.</p><p>When this happens, your doctor may recommend surgery to replace the damaged parts of your knee with new metal and plastic parts.</p><p>You'll most likely be asleep for the surgery, so you won't feel any pain.</p><p>Here's how knee replacement surgery is done ... The damaged cartilage and bone at the end of the thighbone is removed.</p><p>Then a metal cap is placed at the end of the bone.</p><p>The damaged cartilage and bone on the top of the shinbone is removed, and a metal plate is placed into the bone.</p><p>The metal plate has a plastic liner on top that helps the joint move easily.</p><p>The damaged cartilage and bone may also be removed from the back of the kneecap and replaced by a metal plate and plastic liner.</p><p>All these pieces are made to work together like a normal knee joint.</p>"
                },
                "sources": {
                    "mp4_1080p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abn1940/SD/E3/abn1940.mp4?Expires=1526509545&Signature=dMCDq9F46-EpdHfqBpATiZPwiCx0vHhy6y~bkKka17axv6oV0spFpbHQxb7IUgPea-Mi5iFPdnQ5TiQNOXNA7lvS9OPcQGmMh2fLOS0N4FSGyvlYMU-1Z6r2g6Cok~wjfGmF0lvl5fID~wF5LsXYCRRJX3EJl6ecE8SLKSwoa8s_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "mp4_720p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abn1940/SD/E4/abn1940.mp4?Expires=1526509545&Signature=Ag192ZEUt1NgXt5HU-iesVLhUXzCJ~qJb6AZbeor48Y7GdSxzITGh-jggEBRkAbBJbHQJQ82~wo4BDhe6NrJhGdoiqZI6fjqq-WkIG16nZdrmVA0Z-ShZC83kpIAsofQi4dwkVHT2DQXWsTnGC3TLNFAmGAVezFqJHJCsGRt5uU_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "mp4_288p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abn1940/SD/E0/abn1940.mp4?Expires=1526509545&Signature=aaJVy4jbhs6vH4vBY65PVdvmselrnfoemQLZDn3yl5F0~xDFzWilaUTzxK5qRNtPf0zbrOrWf3OMpQMeVrhIYxSQtWI-CqU5sjB2cjC8HeCtBD1jpaPpmdHPS61dwl8I-SivKL05t3wayxi2vEmK7KBd-Q1N17-fhjlDWusa~pA_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "hls_600k_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abn1940/SD/hls/EF1/filesequence.m3u8?Expires=1526509545&Signature=SQBytQBbxIARZrHkaICxSUk5e~vijUCSgUUPVxtzis8irRqBiRMOjJIGkhMw99Lc4yGQDPfyBCVxUkDMN3mVzDVtDIPeyzZXc2rMIMhdEQJMKAos36kAK~Hc5H9YJCBVuPLkXZ6G6P-HvIwFNKJePziO1wHeiWsgY1hcDWHYgSI_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "hls_400k_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abn1940/SD/hls/EF0/filesequence.m3u8?Expires=1526509545&Signature=nSJtcKxNbX8fdUWVEeinZT3oK00ztjGYq~Hip2PByS3pPnTiMxEe5C~ZdOka6Ne5xzVJdhvwm4YEGa7FUVJ9R79vV1qpkpi90mbapu2BRjRvQBFI6nKTPikwfVpv9Q--UhA8Wjf6gDElSe2vpZDMtgz9mHPXl9-anC02hbTDTjs_&Key-Pair-Id=APKAIDLZDAU235UUEL6A"
                },
                "closedCaptions": {
                    "sbv_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abn1940/abn1940.sbv",
                    "srt_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abn1940/abn1940.srt",
                    "vtt_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abn1940/abn1940.vtt",
                    "xml_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abn1940/abn1940.xml"
                },
                "learningObjectiveText": {
                    "html": "<p>The user will learn what knee replacement surgery is and how it is done.</p>"
                },
                "clinicalAbstract": {
                    "html": "<p>Discusses cartilage damage in the knee. Shows how damaged parts of the knee are removed and replaced during surgery.</p>"
                },
                "teaser": {
                    "html": "<p>Learn what to expect during knee replacement surgery and how it can ease the pain of arthritis.</p>"
                },
                "hwid": "abn1940"
            }, {
                "id": "abx0478",
                "version": "2",
                "hash": "2",
                "certifiedDate": "2017-03-21",
                "lang": "en-us",
                "type": "hwVideo",
                "title": {
                    "consumer": "Knee Replacement Surgery: How Others Decided"
                },
                "abstract": {
                    "consumer": "Hear what other people thought about as they decided whether to have knee replacement surgery.",
                    "clinical": "Provides personal stories about why some people choose to have knee replacement surgery while others try medicine or lifestyle changes first."
                },
                "navigable": false,
                "credits": {
                    "author": {
                        "name": "Healthwise Staff"
                    },
                    "primaryReviewers": [{
                        "name": "Adam Husney MD - Family Medicine, Catherine D. Serio PhD - Behavioral Health, David Bardana MD; FRCSC - Orthopedic Surgery; Sports Medicine"
                    }]
                },
                "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwMedia\"><h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">Knee Replacement Surgery: How Others Decided</h3><div class=\"HwVideo\"><video controls=\"true\" preload=\"true\" class=\"HwVideoTag\" crossorigin=\"anonymous\" poster=\"https://assetpool.test.hwapps.net/11.7/en-us/desktop/abp6406/SD/abp6406.jpg\"><source src=\"https://d20bb9v528piij.cloudfront.net/11.7/en-us/abp6406/SD/hls/EF0/filesequence.m3u8?Expires=1526509545&amp;Signature=OicuQybRwXOwalkFqtNDxHM2kV5vn~NrvqlVHw7KehQ8YPxRa0XCxYQfQL6qs57FhCdg71CxaJQ2Ow~LFxmVEIbdhXG58mQnJauZ3zgLGn2RJXn5u8-5ArMXbVSDBp3R1VYG~vBPk3Eof22mKd2DEcDZPvjKDC1AxhG0S3SEydQ_&amp;Key-Pair-Id=APKAIDLZDAU235UUEL6A\" type=\"application/x-mpegURL\" /><source src=\"https://d20bb9v528piij.cloudfront.net/11.7/en-us/abp6406/SD/E0/abp6406.mp4?Expires=1526509545&amp;Signature=WuMMN9qOfffsA-vQ54jpNj-6k1VvWH0Eum3ReLLepMdPiqa1IJp-SgL1n1VStmy6ZNsDHfVXtVVTw5rj5G-V6VWV6Ixr0ZsZNLzHulPQ7v0y52Gzq98DaRkGd0RqtNQs3EyIn1o8K2tzRdqrbpKw0oxK6haWDylB9Lj~mMP1mVk_&amp;Key-Pair-Id=APKAIDLZDAU235UUEL6A\" type=\"video/mp4\" /><track label=\"English\" kind=\"captions\" srclang=\"English\" src=\"https://assetpool.test.hwapps.net/11.7/en-us/desktop/abp6406/abp6406.vtt\" /></video></div></div></div></section>",
                "taxonomy": [{
                    "aspect": {
                        "id": "decisionOverview",
                        "label": "Decision overview",
                        "href": null
                    },
                    "concept": {
                        "id": "HWCV_21977",
                        "label": "Knee Replacement Surgery",
                        "href": null
                    }
                }],
                "aspect": "Decision overview [decisionOverview]",
                "thumbnail": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abp6406/SD/abp6406.jpg",
                "duration": "00:02:34",
                "transcript": {
                    "html": "<p>When you're deciding whether to have knee replacement surgery, it may help to hear what other people thought about as they made their decision.</p><p>[Man's Voice] \"I've been taking pain medicine for the arthritis in my knee, but it just isn't working. I've thought about knee replacement ... but for me, that would be a last resort ... and my doctor said there are plenty of other things I can try first. I know losing some weight would help, so with her advice, I made a plan of swimming and healthy eating to help me slim down. We agree that's the best thing I can do to keep my arthritis from getting worse. She said there are other medicines we can try too.\" [Woman's Voice] \"The pain in my knees ... especially the left one ... has gotten worse and worse over the past 20 years. Now it's so bad, I can't work in my garden anymore ... and I've had to cut back on my exercise classes and volunteer work too. This is making me feel old!</p><p>It's no way to live: in constant pain and not able to do the things I love.</p><p>I know it'll take time and I'll have to do a lot of rehab, but I'm more than willing if it will help me get back to my life.\"</p><p>[Man's Voice] \"I've been an athlete most of my life, and I've had knee injuries and surgeries a few times.</p><p>At this point, my doctor says the only surgery choice I have left is knee replacement.</p><p>My right knee hurts pretty bad sometimes, so part of me would like to go ahead and get it replaced. But I heard that the joints they use only last 10 to 20 years. I worry that if I get a knee replacement at my age, I'll have to have it done again later.</p><p>For now, I'm going to try a different pain medicine.</p><p>As long as I'm able to stay active, I'm going to hold off on surgery.\"</p><p>Like the people you've just heard from, you have your own feelings about the pros and cons of surgery. It's important to share those feelings with your doctor, so that the two of you can talk them over ... combine them with the medical facts ... and choose the best treatment for you.</p>"
                },
                "sources": {
                    "mp4_1080p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abp6406/SD/E3/abp6406.mp4?Expires=1526509545&Signature=Xc2nZFObMLtpRK3iN4-H8kAhpbN7Bn9yUWR7uX28UybNM4teRRr3OAIlN6AXEvBsmumolj8c0JB0cvkMngP5QFE-mU9Z8GEFcYhkehWXJ66bOwNFx6UxQaHTtpCSlqrHzsSM6v8M2ZpT2M2SPqy~FckkRw5Gq2ufxjiaKoupVAQ_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "mp4_720p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abp6406/SD/E4/abp6406.mp4?Expires=1526509545&Signature=LBIWiSTam2zaYMuU75Omf~JNsjbvqtCkSG~MtQ2ZihZ3QlNhanJk7O7j4rUV402TdLgMLxNMWcMXyrus~XSOdVqNs8jojjIac4GzDGmb0w3suU06~AMWY7-POimGdp0vysTvtGaBZSeP2GQG2q0-CtrDhqlREEw2~p21-W23Hug_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "mp4_288p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abp6406/SD/E0/abp6406.mp4?Expires=1526509545&Signature=WuMMN9qOfffsA-vQ54jpNj-6k1VvWH0Eum3ReLLepMdPiqa1IJp-SgL1n1VStmy6ZNsDHfVXtVVTw5rj5G-V6VWV6Ixr0ZsZNLzHulPQ7v0y52Gzq98DaRkGd0RqtNQs3EyIn1o8K2tzRdqrbpKw0oxK6haWDylB9Lj~mMP1mVk_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "hls_600k_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abp6406/SD/hls/EF1/filesequence.m3u8?Expires=1526509545&Signature=QnxuOa6WdouaR1SxpYRDe5F4wQAdCIUWuBGx93RCQPnLKYcccQmr~wXbO8pMd8mIh9q-r~vKU7ahfqPBfOqus7OUZERy4b15884FOyn6nW0w0VmU~vXFZ6HoG0XG81-pi4KeDgoRoBzKaHATRQI5qE4Jm5UCQw1SNcbuh9t11rc_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "hls_400k_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abp6406/SD/hls/EF0/filesequence.m3u8?Expires=1526509545&Signature=OicuQybRwXOwalkFqtNDxHM2kV5vn~NrvqlVHw7KehQ8YPxRa0XCxYQfQL6qs57FhCdg71CxaJQ2Ow~LFxmVEIbdhXG58mQnJauZ3zgLGn2RJXn5u8-5ArMXbVSDBp3R1VYG~vBPk3Eof22mKd2DEcDZPvjKDC1AxhG0S3SEydQ_&Key-Pair-Id=APKAIDLZDAU235UUEL6A"
                },
                "closedCaptions": {
                    "sbv_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abp6406/abp6406.sbv",
                    "srt_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abp6406/abp6406.srt",
                    "vtt_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abp6406/abp6406.vtt",
                    "xml_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abp6406/abp6406.xml"
                },
                "learningObjectiveText": {
                    "html": "<p>Users will gain insights that help them identify their personal preferences about knee surgery.</p>"
                },
                "clinicalAbstract": {
                    "html": "<p>Provides personal stories about why some people choose to have knee replacement surgery while others try medicine or lifestyle changes first.</p>"
                },
                "teaser": {
                    "html": "<p>Hear what other people thought about as they decided whether to have knee replacement surgery.</p>"
                },
                "hwid": "abp6406"
            }, {
                "id": "abx0477",
                "version": "2",
                "hash": "2",
                "certifiedDate": "2017-03-21",
                "lang": "en-us",
                "type": "hwVideo",
                "title": {
                    "consumer": "Knee Replacement Surgery: Pros and Cons"
                },
                "abstract": {
                    "consumer": "Learn about the pros and cons of having knee replacement surgery.",
                    "clinical": "Educates patients about what knee replacement surgery involves and the pros and cons of having it done."
                },
                "navigable": false,
                "credits": {
                    "author": {
                        "name": "Healthwise Staff"
                    },
                    "primaryReviewers": [{
                        "name": "Kathleen Romito MD - Family Medicine, Adam Husney MD - Family Medicine, Jeffrey N. Katz MD; MPH - Rheumatology, David Bardana MD; FRCSC - Orthopedic Surgery; Sports Medicine"
                    }]
                },
                "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwMedia\"><h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">Knee Replacement Surgery: Pros and Cons</h3><div class=\"HwVideo\"><video controls=\"true\" preload=\"true\" class=\"HwVideoTag\" crossorigin=\"anonymous\" poster=\"https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5077/SD/abq5077.jpg\"><source src=\"https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5077/SD/hls/EF0/filesequence.m3u8?Expires=1526509545&amp;Signature=itzNWrjlRE6eajrfw1WvXbD4v4b9ITxkO7wyPlu2JY4o2mrTxXVdte3dCox4OWXyw6Q-sYIC7DAGRAVYbaqgwY51vVUhGmCb4clbo7FQ0UUlu0v-STkJJ2jKT~FtxvVGy-maFaAc4CVHGKVMxybYVXij6CrkEmRyqpLgNljWcHc_&amp;Key-Pair-Id=APKAIDLZDAU235UUEL6A\" type=\"application/x-mpegURL\" /><source src=\"https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5077/SD/E0/abq5077.mp4?Expires=1526509545&amp;Signature=Pzy1BB7PSYqfQXj2jMDs0~fcJA3PYGJcw8PhvIcBUa6jZbSYxZ~w1c~W~6qnkuG9M9FhKaBIL9QwetBUXUqkRlstn4ETxH-LVus8ueW0QXKE1nUo8x5Q3QdEZkS9aH4-q0q8s-zIrmQJHFJKPmyxt4JCuiJ6J6gJsttldyPyWEI_&amp;Key-Pair-Id=APKAIDLZDAU235UUEL6A\" type=\"video/mp4\" /><track label=\"English\" kind=\"captions\" srclang=\"English\" src=\"https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5077/abq5077.vtt\" /></video></div></div></div></section>",
                "taxonomy": [{
                    "aspect": {
                        "id": "decisionOverview",
                        "label": "Decision overview",
                        "href": null
                    },
                    "concept": {
                        "id": "HWCV_21977",
                        "label": "Knee Replacement Surgery",
                        "href": null
                    }
                }],
                "aspect": "Decision overview [decisionOverview]",
                "thumbnail": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5077/SD/abq5077.jpg",
                "duration": "00:02:37",
                "transcript": {
                    "html": "<p>[Dr. Tomek] \"When non-operative treatment no longer controls knee pain, swelling, and other symptoms, surgery is something that we discuss with patients.</p><p>And the surgery that most often gets discussed is total knee replacement.</p><p>In knee replacement, we replace the damaged part of the knee with a metal-and-plastic implant that duplicates the function of the knee and allows bending and rotation of the knee that is much more comfortable than it would be in a severely arthritic joint.</p><p>The major benefit of knee replacement is that it reduces pain in the majority of patients.</p><p>In addition, it improves knee function.</p><p>The ability to painlessly bend and straighten the knee and to put weight on it allows patients to get back to activities that they may have avoided for a long time, such as walking, going up and down stairs and even certain sports ... The downside of knee replacement is that a small number of patients may experience surgical complications, including infection, blood clots, heart or lung risks, which in a small number of patients can be fatal.</p><p>Other patients don't get complete pain relief and may continue to have knee pain for years after the operation that doesn't get better.\"</p><p>[Susan] \"I think, in general, I'm able to do most things that I did before the surgery.</p><p>It's a different type of discomfort and pain.</p><p>I try to do everything I did before. I gave up the bicycle. That I don't do.</p><p>But other than that ... I cut the lawn. I do the gardening.</p><p>I work in the yard in the summertime a lot.\"</p><p>[Dr. Tomek] \"There may be patients who are at greater risk for undergoing knee replacement ... patients who are older ... have more medical conditions, including heart and lung disease or diabetes ... may want to weigh the advantages versus disadvantages of undergoing this procedure.</p><p>Those patients should have a detailed discussion with their physician or provider to determine if knee replacement is truly the right treatment for them.</p><p>In the long term, as knee implants age, some patients may need another operation to replace parts of the implant that have worn out or to replace pieces that have loosened from the bone.\"</p><p>[Azell] \"I know that the knee was good for 15 years.</p><p>So I figured if I didn't run, it would last longer.</p><p>And so that's why I decided to ride ... ride the bike.</p><p>If I had to have it replaced again, I would.</p><p>When I'm in my seventies, I think I'll be fine.</p><p>I think I'll still be riding, still be walking, you know, and able to have a quality of life that I'd like to keep.\"</p>"
                },
                "sources": {
                    "mp4_1080p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5077/SD/E3/abq5077.mp4?Expires=1526509545&Signature=JzzI3uXWDoLt8lAJfS52Qv~r~yeZU40fDq6sYQV6-rcoP3sh1IQBukkaT~ZWlJNc8adROloEFIrCN5H3T73ztry1MvWg7o02TbAJOZ6O8L~H-HRQreXabqsXVJk4eFPIGaRynAsUh9oINsEyj4pwYmuToueFk33enqyEWm9b4J8_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "mp4_720p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5077/SD/E4/abq5077.mp4?Expires=1526509545&Signature=jmGozbQGqiGGF6XzSdk8-Z01MuyIdmWr9oZRxOItRpDgqnnW00c2XxN79BcW2IhGTat~gMzuDzP0RFpD5YbqqOUu1MVW3UdEG2O-eqnOsZ4SVEhiJ53AZYGEcPts27G9kXTtZKFbCw3J~1hus4fZ1gMS9YTTgzob7055JvawnuE_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "mp4_288p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5077/SD/E0/abq5077.mp4?Expires=1526509545&Signature=Pzy1BB7PSYqfQXj2jMDs0~fcJA3PYGJcw8PhvIcBUa6jZbSYxZ~w1c~W~6qnkuG9M9FhKaBIL9QwetBUXUqkRlstn4ETxH-LVus8ueW0QXKE1nUo8x5Q3QdEZkS9aH4-q0q8s-zIrmQJHFJKPmyxt4JCuiJ6J6gJsttldyPyWEI_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "hls_600k_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5077/SD/hls/EF1/filesequence.m3u8?Expires=1526509545&Signature=Nj8n1syMOvJX1tOpvI8wnj7axZ1YQFzTUHionIbp~SOky5Fyi9gf2EEAEFM2N1RCbGZx5rPFtu-n2ACEcXxxgXaD8QRAwnVozw0QvijkKbsWU61T7yLV3U07sF2mjAQsz2ZDS95CMMnrB1d1-bFL3il9MZ9JuTZlc6lKUiUW6AI_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "hls_400k_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5077/SD/hls/EF0/filesequence.m3u8?Expires=1526509545&Signature=itzNWrjlRE6eajrfw1WvXbD4v4b9ITxkO7wyPlu2JY4o2mrTxXVdte3dCox4OWXyw6Q-sYIC7DAGRAVYbaqgwY51vVUhGmCb4clbo7FQ0UUlu0v-STkJJ2jKT~FtxvVGy-maFaAc4CVHGKVMxybYVXij6CrkEmRyqpLgNljWcHc_&Key-Pair-Id=APKAIDLZDAU235UUEL6A"
                },
                "closedCaptions": {
                    "sbv_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5077/abq5077.sbv",
                    "srt_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5077/abq5077.srt",
                    "vtt_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5077/abq5077.vtt",
                    "xml_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5077/abq5077.xml"
                },
                "learningObjectiveText": {
                    "html": "<p>Users will learn about the pros and cons of knee replacement surgery.</p>"
                },
                "clinicalAbstract": {
                    "html": "<p>Educates patients about what knee replacement surgery involves and the pros and cons of having it done.</p>"
                },
                "teaser": {
                    "html": "<p>Learn about the pros and cons of having knee replacement surgery.</p>"
                },
                "hwid": "abq5077"
            }]
        }]
    }],
    "worksConsulted": [{
        "id": "F65038A0-8C64-4520-9E06-F5BC8593DA08",
        "title": "Beswick AD, et al. (2012). What proportion of patients report long-term pain after total hip or knee replacement for osteoarthritis? A systematic review of prospective studies in unselected patients. BMJ Open, 2(1). DOI: 10.1136/bmjopen-2011-000435. Accessed April 24, 2016."
    }, {
        "id": "692A981E-E403-4461-9E48-EE57C1D14F61",
        "title": "Singh JA, et al. (2011). Cardiac and thromboembolic complications and mortality in patients undergoing total hip and total knee arthroplasty. Annals of the Rheumatic Diseases, 70(12): 2082–2088. DOI: 10.1136/ard.2010.148726. Accessed May 25, 2016."
    }, {
        "id": "6CCF73D6-7E57-45C1-B7F2-85E5CA964FDD",
        "title": "Kurtz SM, et al (2010). Prosthetic joint infection risk after TKA in the Medicare population. Clinical Orthopaedics and Related Research, 468(1): 52–56. DOI: 10.1007/s11999-009-1013-5. Accessed May 25, 2016."
    }, {
        "id": "99EA4248-1B3A-4E10-AFAA-4279CE6F240D",
        "title": "Mahomed NN, et al. (2005). Epidemiology of total knee replacement in the United States Medicare population. The Journal of Bone and Joint Surgery. American Volume, 87(6): 1222–1228. http://dx.doi.org/10.2106/JBJS.D.02546 Accessed May 25, 2016."
    }, {
        "id": "60AF3A55-284A-40AA-BE00-17023A512950",
        "title": "Namba RS et al. (2013). Risk factors associated with deep surgical site infections after primary total knee arthroplasty: An analysis of 56,216 knees. The Journal of Bone and Joint Surgery. American volume, 95(9): 775–782. DOI: 10.2106/JBJS.L.00211. Accessed May 25, 2016."
    }, {
        "id": "20B2B008-22CF-4E98-AA5E-5B4339D55819",
        "title": "Katz JN, et al. (2004). Association between hospital and surgeon procedure volume and the outcomes of total knee replacement. The Journal of Bone and Joint Surgery. American Volume, 86-A(9): 1909–1916. http://jbjs.org/content/86/9/1909.long. Accessed May 25, 2016."
    }, {
        "id": "182DA729-DF82-4396-8FF2-0157AA038366",
        "title": "Fernandes L, et al. (2013). European League Against Rheumatism (EULAR) recommendations for the non-pharmacological core management of hip and knee osteoarthritis. Annals of the Rheumatic Diseases, 72(7):1125–1135."
    }, {
        "id": "E9C40C4A-0D04-460F-92AA-27B043B1CA10",
        "title": "Jevsevar DS, et al. (2013). The American Academy of Orthopaedic Surgeons'evidence-based guideline on: treatment of osteoarthritis of the knee, 2nd ed. Journal of Bone and Joint Surgery. American volume, 95(20):1885–1886."
    }, {
        "id": "95E48B29-EE79-469F-B220-0E448CCEFAFC",
        "title": "McAlindon TE, et al. (2014). OARSI guidelines for the non-surgical management of knee osteoarthritis. Osteoarthritis and Cartilage, 22(3): 363–388. DOI: 10.1016/j.joca.2014.01.003."
    }, {
        "id": "99E86BD7-6CDB-4C89-AF8F-F7D6A752405B",
        "title": "National Clinical Guideline Centre (2014). Osteoarthritis: Care and management in adults. London: National Institute for Health and Care Excellence (UK). https://www.nice.org.uk/guidance/CG59."
    }, {
        "id": "0CEE9DFA-84BA-4EB8-95F1-E334D49B6411",
        "title": "Jüni P, et al. (2015). Intra-articular corticosteroid for knee osteoarthritis. Cochrane Database of Systematic Reviews (10). DOI: 10.1002/14651858.CD005328.pub3. Accessed April 24, 2016."
    }, {
        "id": "9EC65FBB-72AF-4F08-A334-8F766EFDECBF",
        "title": "Fransen M, et al. (2015). Exercise for osteoarthritis of the knee. Cochrane Database of Systematic Reviews (1). doi: 10.1002/14651858.CD004376.pub3."
    }, {
        "id": "666A59EE-E16B-41C9-9871-766FC689193C",
        "title": "Hochberg MC, et al. (2012). American College of Rheumatology 2012 recommendations for the use of nonpharmacologic and pharmacologic therapies in osteoarthritis of the hand, hip, and knee. Arthritis Care & Research, 64(4): 465–474."
    }, {
        "id": "0161FBFE-0CF7-45A1-ADC4-39F1FAF25E78",
        "title": "Bartels EM, et al. (2016). Aquatic exercise for the treatment of knee and hip osteoarthritis. Cochrane Database of Systematic Reviews(3). DOI: 10.1002/14651858.CD005523.pub3. Accessed March 17, 2017."
    }, {
        "id": "5459AAA2-71B4-4AB3-B012-55E390F76328",
        "title": "Higuera CA, et al. (2010). Mid-America Orthopaedic Association Physician in Training Award: predictors of early adverse outcomes after knee and hip arthroplasty in geriatric patients, Clinical Orthopaedics and Related Research, 469(5): 1391-1400. Accessed March 17, 2017."
    }],
    "applicationUrl": ""
}



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/actions/mock.js